import { SHOW_UNAUTHORIZED_MESSAGE } from "./actionType";

const INIT_STATE = {
  isUserHaveUnathorizedAccess: false,
};

const UnauthorizedUserReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SHOW_UNAUTHORIZED_MESSAGE:
      return {
        ...state,
        isUserHaveUnathorizedAccess: action.payload,
      };

    default:
      return state;
  }
};

export default UnauthorizedUserReducer;
